import s from './PageLoader.module.css';

interface PageLoaderProps {
  label?: string;
}

export function PageLoader({ label = 'Loading…' }: PageLoaderProps): JSX.Element {
  return (
    <div className={s.root} role="status" aria-live="polite">
      <span className={s.spinner} aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
